<h2 mat-dialog-title>Export</h2>
<div mat-dialog-content>
  <p>Do you wish to export the current slection or the full data set?</p>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end">
  <button mat-raised-button (click)="exportSelection()" [disabled]="isExporting">Export Selection</button>
  <!-- <button mat-raised-button (click)="exportAll()" [disabled]="isExporting">Export All</button> -->
</div>
